module.exports = __webpack_public_path__ + "static/media/slidee-5.013690b8.jpg";